export default "__VITE_ASSET__gfo_ssR1__"